import IconComponent from "icons/IconComponent";

import ForkKnifeIcon from "./ForkKnifeIcon.svg";

export default (ForkKnifeIcon as any) as IconComponent;
